import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Bg from '../../images/shapes/memecoin_bg_shape_2.svg'
import Bg2 from '../../images/shapes/shape_net_2.svg'

const WebDesignTestimonial = () => {

    const testimonials = [
        {
            id: 1,
            paragraph: "I had no idea where to start with my website, but they made it easy. Their web design service took my messy ideas and turned them into a sleek, professional site that actually reflects my brand. I’ve been getting compliments ever since!",
            title: "Melissa R.",
            position: "Boutique Owner",
        },
        {
            id: 2,
            paragraph: "This wasn’t just a web design service, it felt like a creative partnership. They listened, offered smart suggestions, and delivered a site that feels fresh, fast, and easy to navigate. My business finally looks legit online.",
            title: "Jason D.",
            position: "Founder of LuxeGear",
        },
        {
            id: 3,
            paragraph: "What I loved most about their web design service was how easy they made everything. No tech talk, no stress. Just a friendly team who delivered a clean, mobile-friendly site my customers love using.",
            title: "Nina M.",
            position: "Handmade Goods Seller",
        },
        {
            id: 4,
            paragraph: "We saw a real boost in leads after the website redesign. Their web design team didn’t just make it look good; they focused on what actually works. I wish we’d done this sooner!",
            title: "Ethan S.",
            position: "Digital Consultant",
        },
        {
            id: 5,
            paragraph: "Working with them felt like working with friends who also happen to be experts. Their web design service was fast, thoughtful, and, honestly, fun. They nailed our style, and the site works like a charm.",
            title: "Laura T.",
            position: "Nonprofit Director",
        },
    ];

    var settings = {
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        arrows: true,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 340,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <section id="id_memecoin_service_section"
            className={`memecoin_service_section z-2 position-relative testimonials`}
            style={{ backgroundImage: `url(${Bg})`, padding:"50px 0"}}
        >
            <div className="container">
                <div className="memecoin_heading_block text-center">
                    <h2 className="heading_text text-uppercase mb-5">
                        Our Testimonials
                    </h2>
                </div>
                <div className="text-left" data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
                    <Slider {...settings}>
                        {testimonials.map((item, index) => (
                            <div className="" key={index}>
                                <p className="px-3">{item.paragraph}</p>
                                <h4 className="px-3">{item.title}</h4>
                                <p className="px-3">{item.position}</p>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default WebDesignTestimonial;
